import { mapState, mapGetters } from 'vuex'
import { SURVEY, INFO_QUESTIONS, SET_LOADING, SET_QUESTION_ANSWER, GET_DATA_IDX_BY_TYPE, SET_FILES_FOR_DELETE } from '@/store/actions/survey'
import { getFullTextByType, getMessage } from '@/utils/survey'
import { validateFile, uploadFileToS3 } from '@/utils/fileUpload'

export default {
  props: {
    participant: {
      type: Object,
      required: true
    },
    sqCode: {
      type: String,
      required: true
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      s3BucketUrl: `https://${process.env.AWS_BUCKET_NAME}`
    }
  },
  computed: {
    ...mapState(SURVEY, {
      sCode: state => state.s_code,
      waveNumber: state => state.wave_number,
      aboUid: state => state.abo_uid
    }),
    ...mapGetters(SURVEY, {
      questions: INFO_QUESTIONS,
      getIdx: GET_DATA_IDX_BY_TYPE
    }),
    resIdx() {
      return this.getIdx(this.participant.type, this.participant.type_seq);
    },
    question() {
      return this.questions[this.sqCode];
    },
    s3FilePath() {
      return `survey/${this.sCode}/${this.waveNumber}/${this.aboUid}/${getFullTextByType(this.participant, 'en')}`;
    },
    fileData() {
      return this.participant.questions[this.sqCode] || {};
    },
    path() {
      return this.fileData.path;
    },
    originalName() {
      return this.fileData.original_name
    },
    existFileData() {
      return !!this.fileData.path && !!this.fileData.original_name;
    },
    downloadUrl() {
      return this.existFileData ? `${this.s3BucketUrl}/${this.path}/${this.originalName}` : '';
    }
  },
  methods: {
    // 파일 업로드 버튼 클릭
    clickUploadButton(e) {
      e.preventDefault();
      if(this.disabled || this.existFileData) return false;
      this.$refs.attachment.click();
    },
    // AWS S3 Bucket에 파일 업로드
    async uploadAttachment(e) {
      e.preventDefault();
      const file = e.target.files[0];
      if(!file) return false;

      // 1. 파일 체크
      const errMsg = validateFile(file);
      if(errMsg) {
        alert(errMsg);
        return false;
      }

      try {
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, true);
        // 2. 파일명 설정
        const fileName = this.getFileName(file);
        // 3. 파일 S3 업로드
        await uploadFileToS3(`${this.s3FilePath}/${fileName}`, file);
        // 4. 업로드 된 파일 데이터 저장
        this.setFileData(this.s3FilePath, fileName);
      } catch (error) {
        alert(getMessage('ALERT_RETRY'));
        console.error('Upload Attachment ERROR!!', error.stack);
        return;
      } finally {
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
      }
    },
    // AWS S3 Bucket에 저장될 파일명 설정
    getFileName(file) {
      // MAC OS에서 한글 파일명이 NFD 방식으로 저장이 될 수 있기에 NFC로 인코딩
      const fileName = file.name.normalize();
      // 고객이 업로드한 파일명에 현재 시각 밀리세컨드를 붙임(동일한 파일명으로 업로드가 되는 것을 방지하기 위함)
      return fileName.substring(0, fileName.lastIndexOf('.')) + '_' + new Date().getTime() + fileName.substring(fileName.lastIndexOf('.'));
    },
    /**
     * 첨부 파일 삭제
     * - 기존에는 삭제 시 바로 S3에서도 삭제했으나,
     * - 설문을 저장하지 않고 넘어갈 시 첨부파일이 삭제되지 않게 하기 위해
     * - 설문을 저장하는 시점에 S3에서 기존 파일을 일괄 삭제하는 것으로 변경
     */
    async deleteAttachment(e) {
      e.preventDefault();
      // 파일 삭제 전 경고창
      if(!confirm(getMessage('CONFIRM_DELETE_FILE'))) {
        return;
      }

      this.$store.commit(`${SURVEY}/${SET_FILES_FOR_DELETE}`, `${this.path}/${this.originalName}`);
      this.resetFileData();
    },
    downloadFile(e) {
      e.preventDefault();
      if(e.target.value && this.downloadUrl) {
        this.$store.commit(`${SURVEY}/${SET_LOADING}`, true);
        
        window.location.href = this.downloadUrl;

        setTimeout(() => { // 연속 파일 다운로드 클릭 시 버그 수정
          this.$store.commit(`${SURVEY}/${SET_LOADING}`, false);
        }, 500);
        return false;
      }
    },
    setFileData(path, originalName) {
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, {
        idx: this.resIdx,
        sq_code: this.sqCode,
        original_name: originalName,
        path,
        hasError: !originalName || !path
      });
    },
    resetFileData() {
      this.$store.commit(`${SURVEY}/${SET_QUESTION_ANSWER}`, {
        idx: this.resIdx,
        sq_code: this.sqCode,
        original_name: null,
        path: null,
        hasError: false
      });
    }
  },
}


// WEBPACK FOOTER //
// ./src/views/survey2/mixins/AttachmentMixin.js